import { logErrorOnce } from '../helper'

interface Version {
  __REHAJE_COMMIT_HASH__: string
  __REHAJE_PACKAGE__: string
  __REHAJE_VERSION__: string
}

const globalVers = (globalThis.__REHAJE_VERSIONS__ ??= {})

export function createVersion(version: () => Version): string {
  try {
    if (globalThis.FinalizationRegistry === undefined)
      logErrorOnce(`The minimum supported version is chrome 86.`)

    const { __REHAJE_PACKAGE__: pkg, __REHAJE_VERSION__: ver } = version()
    const verPkg = `${ver}${pkg}`

    globalVers[verPkg] ??= 0
    globalVers[verPkg]++
    globalVers[pkg] ??= 0
    globalVers[pkg]++

    if (!/^@rehaje\/(test|umd)/.test(pkg) && globalVers[verPkg] > 1) {
      logErrorOnce(
        'Loading multiple instances will cause conflicts.',
        globalVers,
        pkg
      )
    }

    return ver
  } catch {
    return '0.0.0'
  }
}
